/* Etiquetas multiidoma en castellano. */
export default {
  "dateRangePicker.dateFrom.label": "From",
  "dateRangePicker.dateTo.label": "To",
};
